require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/fn/object/get-own-property-symbols.js
 ** module id = 1213
 ** module chunks = 0
 **/